
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ExternalStockDetails, StockMessage } from '../models/Product';

@Component({
    name: 'AddToCartStock'
})
export default class AddToCartStock extends Vue {
    @Prop({ type: Object, required: false, default: null }) private stockMessage: StockMessage;
    @Prop({ type: Boolean, required: false, default: false }) private inline: boolean;
    @Prop({ type: String, required: false, default: 'top' }) private position: boolean;
    private externalStockMessage: string = null;

    get showStock(): boolean {
        return this.stockMessage != null;
    }

    get icon(): string {
        return this.stockMessage?.icon;
    }

    get color(): string {
        return this.stockMessage?.color;
    }

    get message(): string {
        if (!this.stockMessage?.instock)
            return this.stockMessage.restockmessage ?? this.stockMessage.message;

        return this.stockMessage.message;
    }

    get deliveryMessage(): string {
        if (!this.stockMessage?.showdeliverymessageonlists) return null;

        return this.stockMessage?.deliverymessage;
    }

    get showExternalStock(): boolean {
        if (this.stockMessage?.instock)
            return false;

        if (this.stockMessage?.externalstock1 != null) {
            this.setExternalStockMessage(this.stockMessage.externalstock1);
            return true;
        }

        if (this.stockMessage?.externalstock2 != null) {
            this.setExternalStockMessage(this.stockMessage.externalstock2);
            return true;
        }

        return false;
    }

    setExternalStockMessage(stockDetails: ExternalStockDetails) {
        if (stockDetails.message)
            this.externalStockMessage = stockDetails.message;
    }
}
